export enum TireState {
  NULL = 'NULL',
  
  NEW = 'NEW',

  USED = 'USED',

  RECAP = 'RECAP',

  WASTE = 'WASTE',
}
